import React from 'react';
import CEFMessage from 'components/cef_message/cef_message';
import warningIcon from '../../../assets/images/shared/icons/info.svg';
import useErrorPush from '../../utils/useErrorPush';

class DeliveryDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      deliveryOptions: props.delivery_options,
      uniqueDeliveryDays: [],
      selectedDate: {},
      selectedDeliveryService: {},
      filteredServices: [],
      instructions: '',
      email: props.email,
      telephone: '',
      purchaseOrder: '',
      purchaseOrderRequired: props.purchaseOrderRequired,
      purchaseOrderValid: props.purhcaseOrderRequired === true ? false : true,
      showPurchaseOrderMaskError: false,
      errors: [],
      panelError: false,
      maxChars: 140,
      charsLeft: 140,
      overCharCount: false,
      serviceDatesOpen: false,
      serviceTimesOpen: false,
      basketHasBackOrderItems: this.props.basketHasBackOrderItems,
    };

    this.handleChangeInstructions = this.handleChangeInstructions.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangePurchaseOrder = this.handleChangePurchaseOrder.bind(this);
    this.handleChangeTelephone = this.handleChangeTelephone.bind(this);
    this.formatDeliveryOptions = this.formatDeliveryOptions.bind(this);
    this.setSelectedDeliveryAddress =
      this.setSelectedDeliveryAddress.bind(this);
    this.filterAvailableServicesForSelectedDate =
      this.filterAvailableServicesForSelectedDate.bind(this);
    this.setDeliveryDetails = this.setDeliveryDetails.bind(this);
    this.validatePurchaseOrderMask = this.validatePurchaseOrderMask.bind(this);
    this.setCurrentStep = this.setCurrentStep.bind(this);
    this.validateDeliveryDetails = this.validateDeliveryDetails.bind(this);
    this.validateDeliveryService = this.validateDeliveryService.bind(this);
    this.editThisStep = this.editThisStep.bind(this);
    this.openServicesDates = this.openServicesDates.bind(this);
    this.openServicesTimes = this.openServicesTimes.bind(this);
  }

  componentWillReceiveProps() {
    const {
      delivery_options: deliveryOptions,
      signed_in: signedIn,
      accountTelephone,
      guestTelephone,
    } = this.props;

    this.setState({
      deliveryOptions,
      filteredServices: [],
      uniqueDeliveryDays: [],
      selectedDeliveryService: {},
      selectedDate: {},
      telephone: signedIn ? accountTelephone : guestTelephone,
    });

    this.selectOne.value = 'DEFAULT';
    this.formatDeliveryOptions();
  }

  componentDidMount() {
    this.formatDeliveryOptions();
  }

  handleChangeInstructions(e) {
    const { maxChars } = this.state;
    const input = e.target.value;

    this.setState(
      {
        overCharCount: false,
        charsLeft: maxChars - input.length,
        instructions: input,
      },
      () => {
        if (input.length === maxChars) {
          this.setState({
            overCharCount: true,
          });
        }
      },
    );
  }

  handleChangeEmail(e) {
    this.setState({ email: e.target.value });
  }

  handleChangePurchaseOrder(e) {
    this.setState({ purchaseOrder: e.target.value }, () => {
      this.validateDeliveryDetails();
    });
  }

  handleChangeTelephone(e) {
    this.setState({ telephone: e.target.value }, () => {
      this.validateDeliveryDetails();
    });
  }

  formatDeliveryOptions() {
    const { deliveryOptions } = this.state;

    this.setState({
      uniqueDeliveryDays: _.uniqBy(deliveryOptions, 'day'),
    });
  }

  setSelectedDeliveryAddress(e, mobile) {
    const { filteredServices } = this.state;
    const selectedService = mobile ? JSON.parse(e.target.value) : e;

    var service = filteredServices.filter(s => {
      return s.delivery_service_id == selectedService.delivery_service_id;
    });

    this.setState(
      {
        selectedDeliveryService: service[0],
      },
      () => {
        this.validateDeliveryService();
      },
    );
  }

  filterAvailableServicesForSelectedDate(e, mobile) {
    const { deliveryOptions } = this.state;
    const filteredDate = mobile ? JSON.parse(e.target.value) : e;

    if (mobile) filteredDate.description = '';

    this.setState({ filteredServices: [] }, () => {
      this.setState({
        selectedDate: filteredDate,
        filteredServices: deliveryOptions.filter(delivery => {
          return delivery.day === filteredDate.day;
        }),
        selectedDeliveryService: {},
      });
    });
  }

  setDeliveryDetails() {
    const {
      setDeliveryDetailsUrl,
      setLoadingState,
      showDetailErrors,
      setCurrentStep,
      getSummary,
      nextStep,
      configGenericError,
      toggleGenericError,
    } = this.props;

    const {
      selectedDeliveryService,
      email,
      telephone,
      purchaseOrder,
      instructions,
    } = this.state;

    setLoadingState(true);

    $.ajax({
      url: setDeliveryDetailsUrl,
      method: 'PUT',
      dataType: 'json',
      data: {
        delivery_service: selectedDeliveryService,
        email,
        telephone,
        purchase_order: purchaseOrder,
        instructions,
      },
      success: () => {
        setTimeout(() => {
          setLoadingState(false);
          showDetailErrors(false);
          setCurrentStep(nextStep);
          getSummary();
        }, 1000);
      },
      error: data => {
        setLoadingState(false);
        if (data.status === 500) {
          this.selectOne.value = 'DEFAULT';
          configGenericError({
            title: 'Error',
            body: (
              <div>
                <p>Unfortunately something has gone wrong.</p>

                <p>
                  We are sorry for any inconvenience this may cause. Please try
                  again later. If the problem persists, please contact our
                  customer service team.
                </p>
              </div>
            ),
            errorButton: true,
            errorButtonTitle: 'Refresh Checkout',
            errorButtonAction: toggleGenericError,
            closeAction: toggleGenericError,
            reloadCheckoutAfterClose: true,
            reloadCheckoutAfterErrorButtonAction: true,
          });
        } else {
          this.selectOne.value = 'DEFAULT';
          showDetailErrors(true, data.responseText);
        }
      },
    });
  }

  validatePurchaseOrderMask() {
    const { validatePurchaseOrderMaskUrl } = this.props;
    const { purchaseOrderRequired, purchaseOrder } = this.state;

    if (purchaseOrderRequired) {
      $.ajax({
        url: validatePurchaseOrderMaskUrl,
        method: 'GET',
        dataType: 'json',
        data: {
          purchase_order: purchaseOrder,
        },
        success: () => {
          this.setState({
            purchaseOrderValid: true,
            showPurchaseOrderMaskError: false,
          });
        },
        error: () => {
          this.selectOne.value = 'DEFAULT';
          this.setState({
            purchaseOrderValid: false,
            showPurchaseOrderMaskError: true,
            panelError: true,
          });
        },
      });
    }
  }

  setCurrentStep() {
    const { selectedDeliveryService } = this.state;
    const { day, description, price } = selectedDeliveryService;
    const { nextStep } = this.props;

    switch (nextStep) {
      case 'PAYMENT':
        dataLayer.push({
          event: 'deliveryOptions',
          day,
          description,
          price,
        });

        if (this.validateDeliveryDetails()) {
          this.setDeliveryDetails();
        }
        break;
      case 'COLLECTION_DETAILS':
        if (this.validateDeliveryDetails()) {
          this.setDeliveryDetails();
        }
        break;
    }
  }

  validateDeliveryService() {
    const { selectedDeliveryService } = this.state;

    this.setState({ errors: [] });

    if (_.isEmpty(selectedDeliveryService)) {
      this.selectOne.value = 'DEFAULT';
      this.setState(prevState => ({
        errors: [
          ...prevState.errors,
          { message: 'Please select a Delivery Date/Time' },
        ],
      }));
    }
  }

  validateDeliveryDetails() {
    const { purchaseOrderRequired, signed_in: signedIn } = this.props;
    const { purchaseOrder, email, telephone, errors } = this.state;

    let valid = false;

    this.setState({ errors: [] });

    if (purchaseOrderRequired) {
      if (purchaseOrder === '') {
        this.selectOne.value = 'DEFAULT';
        const purchaseOrderErrorMessage = 'A Purchase Order must be provided';
        useErrorPush(purchaseOrderErrorMessage, window.dataLayer);
        this.setState(prevState => ({
          errors: [...prevState.errors, { message: purchaseOrderErrorMessage }],
        }));
      }
    }

    if (signedIn) {
      const emailRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!emailRegex.test(email)) {
        const emailErrorMessage = 'E-Mail Invalid';
        useErrorPush(emailErrorMessage, window.dataLayer);
        this.setState(prevState => ({
          errors: [...prevState.errors, { message: emailErrorMessage }],
        }));
      }

      if (telephone.length === 0) {
        const tradeTelephoneErrorMessage =
          'Please enter a Telephone Number, this will only be used to provide updates on this order';
        useErrorPush(tradeTelephoneErrorMessage, window.dataLayer);
        this.setState(prevState => ({
          errors: [
            ...prevState.errors,
            {
              message: tradeTelephoneErrorMessage,
            },
          ],
        }));
      }
    }

    valid = errors.length === 0 ? true : false;

    this.setState({
      panelError: errors.length === 0 ? false : true,
    });

    return valid;
  }

  editThisStep() {
    const { clearDeliveryService, setCurrentStep } = this.props;

    // should we do a clear down as we're moving back and get updated delivery options?
    this.selectOne.value = 'DEFAULT';
    clearDeliveryService();
    setCurrentStep('DELIVERY_DETAILS');
  }

  openServicesDates() {
    const { serviceDatesOpen } = this.state;
    this.setState({ serviceDatesOpen: !serviceDatesOpen });
  }

  openServicesTimes() {
    const { serviceTimesOpen } = this.state;
    this.setState({ serviceTimesOpen: !serviceTimesOpen });
  }

  render() {
    const {
      purchaseOrderRequired,
      signed_in: signedIn,
      nextStepText,
      current_step: currentStep,
      show_display_error: pShowDisplayError,
      display_errors: displayErrors,
      processingState,
      step,
      guestTelephone,
      deliveryMessaging,
    } = this.props;

    const {
      errors,
      selectedDeliveryService,
      email,
      telephone,
      panelError,
      selectedDate,
      uniqueDeliveryDays,
      filteredServices,
      overCharCount,
      charsLeft,
      instructions,
      purchaseOrder,
    } = this.state;

    const purchaseOrderRequiredAsterix = purchaseOrderRequired === true && (
      <strong className="required">*</strong>
    );

    let nextStep = null;

    if (signedIn === true) {
      nextStep = errors.length == 0 &&
        !_.isEmpty(selectedDeliveryService) &&
        email != '' && (
          <div className="checkout-sub-panel fl-on fl-sm-on next-step">
            <button
              onClick={this.setCurrentStep}
              className="set-delivery-details-button next-panel">
              Continue to {nextStepText}
            </button>
          </div>
        );
    } else {
      nextStep = ((errors.length == 0 && !_.isEmpty(selectedDeliveryService)) ||
        email === '') && (
        <div className="checkout-sub-panel fl-on fl-sm-on next-step">
          <button
            onClick={this.setCurrentStep}
            className="set-delivery-details-button next-panel">
            Continue to {nextStepText}
          </button>
        </div>
      );
    }

    let deliveryErrors = '';
    if (errors.length > 0) {
      useErrorPush(
        'checkout: continue to payment button is disabled',
        window.dataLayer,
      );
      deliveryErrors = (
        <ul className="errors">
          {errors.map((e, i) => {
            return <li key={i}>{e.message}</li>;
          })}
        </ul>
      );
    }

    const editStep = (currentStep == 'PAYMENT' ||
      currentStep === 'COLLECTION_DETAILS') && (
      <strong className="pull-right edit" onClick={this.editThisStep}>
        Edit
      </strong>
    );

    const completedStep = (currentStep === 'PAYMENT' ||
      currentStep === 'COLLECTION_DETAILS') && <i className="icon-ok" />;

    const showDisplayError = pShowDisplayError && (
      <div className="showPaymentDisplayError">
        <ul className="errors">
          {displayErrors.map((errorMessage, index) => {
            return <li key={index}>{errorMessage}</li>;
          })}
        </ul>
      </div>
    );

    const showBackOrderWarning = this.state.basketHasBackOrderItems && (
      <p className="back-order__warning fl ai-c jc-c">
        <img
          className="mr-8"
          src={this.props.warningIcon}
          alt=""
          width="20"
          height="18"
        />
        Delivery dates for out of stock items can not be guaranteed
      </p>
    );

    return (
      <div
        className={
          'checkout-panel delivery-details-step ' +
          (currentStep !== 'DELIVERY_DETAILS' ? 'not-active' : '') +
          (processingState === true ? ' processing-payment' : '')
        }>
        <div className="checkout-header-title">
          <div className="checkout-header-title-left">
            {panelError === true && <i className="icon-info-sign" />}
            <strong>{step}.</strong> Delivery Options {completedStep}
          </div>
          <div className="checkout-header-title-right">{editStep}</div>
        </div>

        <div className="checkout-sub-panel delivery-details">
          {showDisplayError}
          {showBackOrderWarning}
          <p>Please select a delivery date</p>

          <select
            onChange={e => {
              this.filterAvailableServicesForSelectedDate(e, true);
            }}
            className="available--delivery-dates-select"
            ref={e => (this.selectOne = e)}
            defaultValue={selectedDate.day ? selectedDate.day : 'DEFAULT'}>
            <option value="DEFAULT" disabled>
              Select a delivery date
            </option>
            {uniqueDeliveryDays.map((d, i) => {
              return (
                <option key={i} value={JSON.stringify(d)}>
                  {d.day}
                </option>
              );
            })}
          </select>

          <div className={'available--delivery-dates '}>
            {uniqueDeliveryDays.map((d, i) => {
              let selectedClass = '';
              if (selectedDate.day !== undefined) {
                selectedClass = selectedDate.day === d.day ? 'selected' : '';
              }
              return (
                <a
                  key={i}
                  onClick={() => {
                    this.filterAvailableServicesForSelectedDate(d);
                  }}
                  className={selectedClass}>
                  {d.day}
                </a>
              );
            })}
          </div>

          {selectedDate.day !== undefined &&
            selectedDate.approval_cutoff_date !== null && (
              <p className="delivery-details__warning">
                This order will need to be approved by{' '}
                <b>{selectedDate.approval_cutoff_date}</b> to be delivered on{' '}
                <b>{selectedDate.day}</b>
              </p>
            )}

          {filteredServices.length > 0 && (
            <>
              {deliveryMessaging?.premium_carrier_services && (
                <CEFMessage
                  icon={warningIcon}
                  text={deliveryMessaging.premium_carrier_services}
                />
              )}
              <p>Please select a delivery time</p>
            </>
          )}

          {filteredServices.length > 0 && (
            <select
              onChange={e => {
                this.setSelectedDeliveryAddress(e, true);
              }}
              className="available--delivery-times-select"
              defaultValue={
                selectedDate.description !== ''
                  ? `${selectedDate.description - selectedDate.price}`
                  : 'DEFAULT'
              }>
              <option value="DEFAULT" disabled>
                Select a delivery time
              </option>
              {filteredServices.map((d, i) => {
                return (
                  <option key={i} value={JSON.stringify(d)}>
                    {d.description} - {d.price}
                  </option>
                );
              })}
            </select>
          )}

          <div className={'available--delivery-dates times-and-prices '}>
            {filteredServices.map((d, i) => {
              let selectedClass = '';
              if (selectedDeliveryService.delivery_service_id !== undefined) {
                selectedClass =
                  selectedDeliveryService.delivery_service_id ===
                  d.delivery_service_id
                    ? 'selected'
                    : '';
              }
              return (
                <a
                  key={i}
                  onClick={() => {
                    this.setSelectedDeliveryAddress(d, false);
                  }}
                  className={selectedClass}>
                  {d.description} - {d.price}
                </a>
              );
            })}
          </div>

          {!_.isEmpty(selectedDeliveryService) && (
            <div>
              <hr />
              {signedIn === false && (
                <div>
                  <p>
                    <strong>Additional Information</strong>
                  </p>
                  <p>
                    An order confirmation will be sent to the following email
                    address:
                  </p>
                  <div className="fl-on fl-jc-sb ">
                    <div className="fl-fb-50">
                      <label>Email</label>
                      <p className="notes-reference-info">{email}</p>
                    </div>
                    <div className="fl-fb-50">
                      <label>Telephone</label>
                      <p className="notes-reference-info">{guestTelephone}</p>
                    </div>
                  </div>
                  <hr />
                </div>
              )}

              <p>
                <strong>
                  {signedIn === false
                    ? 'Order Notes'
                    : 'Add Special Delivery Instructions'}
                </strong>
              </p>

              {overCharCount ? (
                <p className="char-count over-count">140 characters only</p>
              ) : (
                <p className="char-count">{charsLeft} characters remaining</p>
              )}

              <textarea
                onChange={this.handleChangeInstructions}
                value={instructions}
                maxLength="140"
              />

              <p className="notes-reference-info">
                <i className="icon-info-sign" />
                If you are leaving notes reference the delivery, as we use third
                party couriers we cannot guarantee they will see or follow these
                notes.
              </p>

              <div className={signedIn === false ? 'hidden' : ''}>
                <p>
                  <strong>
                    An order confirmation will be sent to the following email
                    address:
                  </strong>
                </p>
              </div>
              <div
                className={
                  'fl-on fl-jc-sb ' + (signedIn === false ? 'hidden' : '')
                }>
                <div className="fl-fb-50">
                  <label>
                    E-Mail <strong className="required">*</strong>
                  </label>
                  <input
                    type="text"
                    onChange={this.handleChangeEmail}
                    onBlur={this.validateDeliveryDetails}
                    autoComplete="no"
                    value={email}
                  />
                </div>
                <div className="fl-fb-50">
                  <label>
                    Telephone <strong className="required">*</strong>
                  </label>
                  <input
                    type="text"
                    onChange={this.handleChangeTelephone}
                    value={telephone}
                    autoComplete="no"
                  />
                </div>
              </div>
              <div className={'fl-on fl-jc-sb '}>
                <div className="fl-fb-50">
                  <label>
                    {signedIn === true ? 'Purchase Order ' : 'Your Reference '}
                    {purchaseOrderRequiredAsterix}
                  </label>
                  <input
                    type="text"
                    onChange={this.handleChangePurchaseOrder}
                    onBlur={this.validatePurchaseOrderMask}
                    value={purchaseOrder}
                    autoComplete="no"
                  />
                </div>
              </div>

              {deliveryErrors}
            </div>
          )}
        </div>

        {nextStep}
      </div>
    );
  }
}

export default DeliveryDetails;
